import { getEnvVariableByKey } from '../../../utils/tenantUtils';

export const HANDOFF_RESPONSE_TIMEOUT_MS = 10000;

export const HANDOFF_SESSION_PARAM =
  getEnvVariableByKey('REACT_APP_HANDOFF_SESSION_PARAM') ?? 'sessionUuid';

export const HANDOFF_SESSION_REQUIRED_FIELDS: Record<string, string[]> = {
  MMAPC: ['identifier_posId', 'accountInfo_extAccountId'],
  MMAPOS: [
    'identifier_posId',
    'accountInfo_extAccountId',
    'clientInfo_employeeNumber',
    'clientInfo_employeeName',
  ],
};

export const getMissingHandoffFields = (
  project: string,
  handoffData: Record<string, string>
): string[] => {
  const requiredFields = HANDOFF_SESSION_REQUIRED_FIELDS[project] ?? [];
  return requiredFields.filter((field) => !handoffData[field]?.trim());
};

export const getHandoffErrorRoute = (project: string): string => {
  try {
    const routes: Record<string, string> = JSON.parse(
      getEnvVariableByKey('REACT_APP_HANDOFF_ERROR_ROUTES') ?? '{}'
    );
    return routes[project] ?? routes['default'] ?? 'error';
  } catch {
    return 'error';
  }
};
